import React from 'react';
import GridList from '../gridList/GridList';

const CardViewFormExtGrid = ({ section, options }) => {
    return <GridList type={section.meta.gridConfig} options={options} />;
};

export default CardViewFormExtGrid;
